import React, { useState } from 'react'
import Select from 'react-select'
import { Button, Input, Spinner } from 'reactstrap'
import UnignoreDate from './UnignoreDate'

export const DropDownEditor = (props) => {
  const {
    value,
    onUpdate,
    dateValue,
    excludedValue,
    forceUpdate,
    isMulti,
    isStatus,
    options,
    isClearable,
    showExclude,
    hideActions,
    valueChanged,
    reasonChanged,
    ignoredChanged,
  } = props
  const [selectedOption, setSelectedOption] = useState('')

  let theValue
  let existingDate
  if (isStatus) {
    const selectOptions = [
      { label: 'Active', value: 0 },
      { label: 'Inactive', value: 1 },
      { label: 'Ignored', value: 2 },
    ]

    theValue = selectOptions.find((s) => s.value === value)
  } else {
    theValue = value
  }

  const [selectedValue, setSelectedValue] = useState(theValue)
  const [excluded, setExcludedValue] = useState(excludedValue)
  const [hasSelected, setHasSelected] = useState(false)

  if (dateValue !== null && dateValue !== undefined) {
    existingDate = new Date(dateValue)
  }

  const [selectedDate, setSelectedDate] = useState(existingDate)
  const [saving, setSaving] = useState(false)
  const [saveEnabled, setSaveEnabled] = useState(false)

  const handleStatusChange = (selectedOption) => {
    setSelectedValue(selectedOption);
    if(typeof valueChanged === 'function'){
      valueChanged(selectedOption);
    }
    if (selectedOption != null) {
      setHasSelected(true)
    } else {
      setHasSelected(false)
    }
  }

  const handleOptionChange = (option) => {
    if (option.target.value && option.target.value !== '') {
      setSaveEnabled(true)
    }
    if(typeof reasonChanged === 'function')
      reasonChanged(option.target?.value);
    
    setSelectedOption(option.target.value)
  }

  const handleExcludedChange = () => {
    setExcludedValue(!excluded)
  }

  const handleClick = () => {
    if (selectedOption !== '') {
      setSaving(true)
      onUpdate({
        selectedValue: selectedValue,
        selectedOption: selectedOption,
        selectedDate: selectedDate,
        excluded: excluded,
      })
      setSaving(false)
      forceUpdate()
    }
  }

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if(typeof ignoredChanged == 'function'){
      ignoredChanged(date);
    }
  }

  let editorArray = [
    <Select
      key={0}
      isMulti={isMulti}
      isClearable={isClearable}
      options={options}
      onChange={handleStatusChange}
      value={selectedValue}
    />,
    <UnignoreDate
      key={1}
      selectedDate={selectedDate}
      handleDateChange={handleDateChange}
      selectedValue={selectedValue}
    />,
    <Input
      key={2}
      style={{ marginTop: '5px', marginBottom: '5px' }}
      value={selectedOption}
      onChange={handleOptionChange}
      id="reasonId"
      type="textarea"
      placeholder="Reason for Change"
    />,
    <Button key={4} size="sm" color="primary" disabled={!saveEnabled} onClick={handleClick}>
      {saving ? (
        <span>
          <Spinner style={{ height: '1.15rem', width: '1.15rem' }} color="light" /> Saving
        </span>
      ) : (
        'Save'
      )}
    </Button>,
    <Button key={5} style={{ float: 'right' }} size="sm" outline color="secondary" onClick={forceUpdate}>
      close
    </Button>,
  ]

  if (showExclude === true) {
    editorArray.splice(
      2,
      0,
      <label key={3}>
        <input type="checkbox" disabled={!hasSelected} checked={excluded} onChange={handleExcludedChange} /> Excluded
        From Agreement
      </label>
    )
  }

  if(hideActions === true){
    editorArray.splice(-2 , 2);
  }

  return editorArray
}
